
import { computed } from "vue";
import { Options, Vue } from "vue-class-component";

@Options({
  props: [
    "class",
    "padding",
    "margin",
    "height",
    "width",
    "style",
    "label",
    "disabled",
    "theme",
    "size",
    "value",
    "type",
    "name",
    "msg",
    "rules",
    "icon",
    "iconPos",
    "fontSize"
  ]
})
export default class BaseElement extends Vue {
  public label!: string;
  public disabled!: boolean;
  public theme!: string;
  public size!: string;
  public value!: any;
  public type!: string;
  public name!: string;
  public msg!: string;
  public rules!: [];
  public icon!: string;
  public iconPos!: string;
  public class!: string;
  //Style
  public fontSize!: string;
  public padding!: string;
  public margin!: string;
  public height!: string;
  public width!: string;
  public style!: any;
  public bindingClass = computed(() => this.class);
}
